export default "__VITE_ASSET__Dx3cF3uo__"